// AuthProvider — HttpOnly cookie carries the session; the SPA learns who it is
// via /api/auth/me on boot. Exposes { user, loading, signOut, refresh }.
// user = { userId, clientId, email, displayName, role, isStaff } or null.

import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { AuthApi } from "../hooks/useApi.js";

const AuthContext = createContext({ user: null, loading: true, signOut: () => {}, refresh: () => {} });

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      setUser(await AuthApi.me());
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const signOut = useCallback(async () => {
    try { await AuthApi.logout(); } catch { /* cookie may already be gone */ }
    window.location.href = "/login";
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading, signOut, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
